import { FagomradeType, LenkeType, type Verktoy } from '@src/types/minhelseentities';

import { track } from '@helsenorge/framework-utils/amplitude';
import { ApnetVerktoy, type ApnetVerktoyProperties, SettVerktoyside } from '@helsenorge/framework-utils/amplitude/ampli';

export const VerktoyKilde = {
  AppStore: 'app store',
  GooglePlay: 'google play',
  InternLenke: 'intern lenke',
  EksternLenke: 'ekstern lenke',
} as const satisfies Record<string, NonNullable<ApnetVerktoyProperties['verktoyKilde']>>;

export const mapLenkeTypeToVerktoyKilde = (lenkeType: LenkeType, interntVerktoy?: boolean): ApnetVerktoyProperties['verktoyKilde'] => {
  switch (lenkeType) {
    case LenkeType.NedlastingAppIphone:
      return VerktoyKilde.AppStore;
    case LenkeType.NedlastingAppAndroid:
      return VerktoyKilde.GooglePlay;
    case LenkeType.Standard:
      return interntVerktoy ? VerktoyKilde.InternLenke : VerktoyKilde.EksternLenke;
    default:
      return undefined;
  }
};

export const sporAapningAvVerktoy = (verktoyNavn: string, lenkeType: LenkeType, interntVerktoy: boolean): void => {
  track(
    new ApnetVerktoy({
      handling: 'åpne',
      objekt: 'verktøy',
      verktoyKilde: mapLenkeTypeToVerktoyKilde(lenkeType, interntVerktoy),
      verktoyNavn: verktoyNavn,
    })
  );
};

export const sporAapningAvVerktoyFraLenke = (verktoy: Verktoy, lenkeType: LenkeType): void => {
  sporAapningAvVerktoy(verktoy.Navn, lenkeType, verktoy.InterntVerktoy);
};

export const sporSettVerktoyside = (verktoy: Verktoy): void => {
  track(
    new SettVerktoyside({
      handling: 'se',
      objekt: 'verktøyside',
      tjeneste: 'verktøy',
      verktoyNavn: verktoy.Navn,
      fagligAnsvarlig: [verktoy.FagligAnsvarlig],
      fagomrade: verktoy.Fagomrader.map(f => FagomradeType[f]),
    })
  );
};
